import typeToReducer from 'type-to-reducer';
import get from 'lodash.get';
import first from 'lodash.first';
import last from 'lodash.last';

import { DEFAULT_METRIC_CODE, DEFAULT_ASSET } from '../../constants/app';

import * as fmt from '../../utils/formatters';

import { RESET_STORE } from '../resetStore/actions';
import * as actions from './actions';

const initialState = {
  asset: DEFAULT_ASSET,
  metricCode: DEFAULT_METRIC_CODE,
  downloadLoadings: {
    json: false,
    csv: false,
  },
  metrics: {
    data: [],
    loading: false,
    err: false,
    errMsg: '',
  },
  dependency: {
    data: [],
    loading: false,
    err: false,
    errMsg: '',
  },
  prices: {
    data: [],
    loading: false,
    err: false,
    errMsg: '',
  },
  plotRange: [],
};

export default typeToReducer(
  {
    [actions.GET_METRIC]: {
      PENDING: (state) => {
        return {
          ...state,
          metrics: {
            ...state.metrics,
            loading: true,
            err: false,
          },
        };
      },
      FULFILLED: (state, action) => {
        const data = action.payload;
        const firstDate = get(first(data), 't');
        const lastDate = get(last(data), 't');

        // Storing dates in utc string format. Similar to explorer.
        const fDate = fmt.utcString(firstDate);
        const lDate = fmt.utcString(lastDate);

        return {
          ...state,
          metrics: {
            ...state.metrics,
            data,
            loading: false,
          },
          plotRange: [fDate, lDate],
        };
      },
      REJECTED: (state, action) => ({
        ...state,
        metrics: {
          ...state.metrics,
          loading: false,
          err: true,
          errMsg: action.payload.message,
        },
      }),
    },
    [actions.GET_DEPENDENCY]: {
      PENDING: (state) => {
        return {
          ...state,
          dependency: {
            ...state.dependency,
            loading: true,
            err: false,
          },
        };
      },
      FULFILLED: (state, action) => {
        const data = action.payload;

        return {
          ...state,
          dependency: {
            ...state.dependency,
            data,
            loading: false,
          },
        };
      },
      REJECTED: (state, action) => ({
        ...state,
        dependency: {
          ...state.dependency,
          loading: false,
          err: true,
          errMsg: action.payload.message,
        },
      }),
    },

    [actions.GET_PRICES]: {
      PENDING: (state) => ({
        ...state,
        prices: {
          ...state.prices,
          loading: true,
          err: false,
        },
      }),
      FULFILLED: (state, action) => {
        const data = action.payload;

        return {
          ...state,
          prices: {
            ...state.prices,
            data,
            loading: false,
          },
        };
      },
      REJECTED: (state, action) => ({
        ...state,
        prices: {
          ...state.prices,
          loading: false,
          err: true,
          errMsg: action.payload.message,
        },
      }),
    },

    [actions.CHANGE_METRIC]: (state, action) => {
      const { metricCode } = action.payload;

      return {
        ...state,
        metricCode,
        metrics: initialState.metrics,
        dependency: initialState.dependency,
      };
    },

    [actions.CHANGE_ASSET]: (state, action) => ({
      ...state,
      asset: action.payload.asset,
    }),

    [actions.DOWNLOAD_METRIC_DATA]: {
      PENDING: (state, action) => ({
        ...state,
        downloadLoadings: {
          ...state.downloadLoadings,
          [action.format]: true,
        },
      }),
      FULFILLED: (state, action) => ({
        ...state,
        downloadLoadings: {
          ...state.downloadLoadings,
          [action.format]: false,
        },
      }),
      REJECTED: (state, action) => ({
        ...state,
        downloadLoadings: {
          ...state.downloadLoadings,
          [action.format]: false,
        },
      }),
    },
    [RESET_STORE]: () => ({
      ...initialState,
    }),
  },
  initialState,
);
